import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { LOST_REASON_OTHER } from '../../constants/activity';
import { usePipelineConfig } from '../../providers/PipelineConfigProvider';

/**
 * Auswahl eines Verlustgrunds (kuratierte Liste statt Freitext-Prompt).
 * Die Liste kommt aus der Pipeline-Konfiguration (B3, im Admin gepflegt).
 * „Sonstiges" blendet ein Freitextfeld ein. Grund ist optional — ohne Auswahl
 * wird der Datensatz ohne Grund abgelehnt.
 *   onConfirm(reason: string)  – aufgerufen mit dem gewählten/eingegebenen Grund
 */
export default function LostReasonDialog({ open, onClose, onConfirm, title = 'Als abgelehnt markieren' }) {
  const { lostReasons } = usePipelineConfig();
  const [choice, setChoice] = useState('');
  const [custom, setCustom] = useState('');

  const reason = choice === LOST_REASON_OTHER ? custom.trim() : choice;

  const handleClose = () => {
    setChoice('');
    setCustom('');
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(reason);
    setChoice('');
    setCustom('');
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Warum ist es nicht zustande gekommen? Das hilft später bei der Auswertung.
          </Typography>
          <FormControl fullWidth>
            <InputLabel id="lost-reason-label">Grund</InputLabel>
            <Select
              labelId="lost-reason-label"
              value={choice}
              label="Grund"
              onChange={(e) => setChoice(e.target.value)}
            >
              <MenuItem value=""><em>Kein Grund angegeben</em></MenuItem>
              {lostReasons.map((r) => (
                <MenuItem key={r} value={r}>{r}</MenuItem>
              ))}
              <MenuItem value={LOST_REASON_OTHER}>{LOST_REASON_OTHER} …</MenuItem>
            </Select>
          </FormControl>
          {choice === LOST_REASON_OTHER && (
            <TextField
              fullWidth autoFocus label="Grund (Freitext)"
              value={custom}
              onChange={(e) => setCustom(e.target.value)}
              placeholder="Kurz beschreiben …"
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose}>Abbrechen</Button>
        <Button onClick={handleConfirm} variant="contained" color="error">Als abgelehnt markieren</Button>
      </DialogActions>
    </Dialog>
  );
}
